import classNames from 'classnames';
import { FC } from 'react';
import styles from './ListHeader.module.css';

interface ListHeaderProps {
  'category': string;
  'isNoCategory'?: boolean;
  'hideDivider'?: boolean;
  'className'?: string;
  'data-testid'?: string;
}

const ListHeader: FC<ListHeaderProps> = ({
  category,
  isNoCategory,
  hideDivider,
  className,
  'data-testid': testId = `dropdownListCategory-${isNoCategory ? 'others' : category}`,
}) => (
  <li className={classNames(styles.listHeader, { [styles.noDivider]: hideDivider }, className)} data-testid={testId}>
    {category}
  </li>
);

export default ListHeader;
